export default __webpack_public_path__ + "static/media/daniel-wolfson.2b4c6707.jpg";